import React, {useEffect, useState} from 'react';
import '../../styles/Commons.css';
import '../../styles/HistorialPanel.css';
import {Table, Tag} from "antd";
import type {ColumnsType, TableProps} from 'antd/es/table';
import {GetHistorialByPantalla} from "../../dao/GetHistorialByPantalla";
import {Historial} from "../../model/Historial";
import {BiRefresh, BiChevronUp} from "react-icons/bi";

interface historialPantalla {
    pantalla: string,
    pagina: string
}

const Historials: React.FC<historialPantalla> = ({pantalla, pagina}) => {

    const [historial, setHistorial] = useState<Historial[]>([]);
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        checkHistorial();
    }, []);

    async function checkHistorial() {
        setLoading(true);
        const historials = await GetHistorialByPantalla(pantalla, pagina);
        setHistorial(historials);
        setLoading(false);
    }

    function checkDates(a: string, b: string) {
        return new Date(b).getTime() - new Date(a).getTime();
    }

    const columns: ColumnsType<Historial> = [
        {
            key: 'missatge', title: 'Missatge', dataIndex: 'missatge', width: 30,
        },
        {
            key: 'tipus', title: 'Tipus', dataIndex: 'tipus', width: 20,
            render: (tipus: number) => (
                <Tag color={tipus == -1 ? "magenta" : (tipus == 0 ? "cyan" : "lime")}>
                    {tipus == -1 ? "eliminat" : (tipus == 0 ? "modificat" : "afegit")}
                </Tag>
            ),
        },
        {
            key: 'moment', title: 'Moment', dataIndex: 'moment', width: 30,
            sorter: (a, b) => checkDates(a.moment, b.moment),
            sortOrder: "ascend",
            render: (moment: string) => (
                <p>{moment.substring(0, moment.lastIndexOf(":") + 3)}</p>
            ),
        },
        {
            key: 'usuari', title: 'Usuari', dataIndex: 'usuari', width: 20,
        },
    ];

    const tableProps: TableProps<Historial> = {loading};

    function toggle() {
        const next = !open;
        setOpen(next);
        if (next) checkHistorial();
    }

    return (
        <div className={`hp-panel ${open ? 'hp-open' : ''}`}>
            <div className="hp-bar" onClick={toggle}>
                <div className="hp-bar-title">
                    <span className="hp-bar-arrow"><BiChevronUp/></span>
                    Historial
                </div>
                <div className="hp-bar-actions">
                    <button
                        className="hp-refresh"
                        title="Refrescar"
                        onClick={(e) => {
                            e.stopPropagation();
                            checkHistorial();
                        }}
                    >
                        <BiRefresh/>
                    </button>
                </div>
            </div>
            {open && (
                <div className="hp-body">
                    <Table
                        {...tableProps}
                        rowKey={(r, i) => `${r.moment}-${i}`}
                        columns={columns}
                        dataSource={historial}
                        pagination={{pageSize: 50}}
                        size="small"
                    />
                </div>
            )}
        </div>
    );
};

export default Historials;
